// NATIVE 
import * as React from 'react';



// INSTALLED 
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import DeleteIcon from '@mui/icons-material/Delete';
import Menu, { MenuProps } from '@mui/material/Menu';
import { styled, alpha  } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import TableContainer from '@mui/material/TableContainer';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Card, Chip, Pagination, TablePagination } from '@mui/material';




// CUSTOM 
import { SnackAlert } from '../SnackAlert';
import MultipleSnackbars from '../MultipleSnackbars';
import { showNumberRowsTable } from '../../commons/utils/values';
import { ModalSessionExpired } from '../generics/ModalSessionExpired';
import { closeSessionGlobal, hasPemissions } from '../../commons/utils';
import {  getTipoNovedadByPagination } from '../../store/tipo_novedad';
import { paddingCardsTables, timeToClosedToast } from '../../commons/values';
import { getUsuariosPermisosStore, storeActiveUserPermission, storeDesActiveUserPermission, storeDetailUserPermission } from '../../store/users_permissions';
import { AvatarTables } from '../AvatarTables';








const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.secondary.contrastText,
    fontSize: 15,
    fontWeight: 700
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontWeight: 500,
    color: '#2e263de6'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));





/**
 * TableUsuariosPermisos component renders a table displaying user permissions.
 * It fetches data from a Redux store and provides functionalities to view, edit, 
 * deactivate, and restore user permissions.
 *
 * @component
 *
 * @returns {JSX.Element} The rendered component.
 *
 * @example
 * <TableUsuariosPermisos />
 *
 * @remarks
 * This component uses several React hooks:
 * - `useNavigate` for navigation.
 * - `useDispatch` and `useSelector` for Redux state management.
 * - `useState` for managing local state.
 * - `useEffect` for side effects.
 *
 * The component also includes styled components for custom styling and Material-UI components 
 * for UI elements like Table, Menu, Button, etc.
 *
 * @function getDataUsersPemissions
 * Fetches user permissions data from the store and validates permissions.
 *
 * @function showUserPermissionsDetail
 * Navigates to the user permissions detail page after validating permissions.
 *
 * @function showEditUserPermission
 * Navigates to the edit user permissions page after validating permissions.
 *
 * @function desactiveUserPermission
 * Deactivates a user permission after validating permissions.
 *
 * @function restoreUserPermission
 * Restores a user permission after validating permissions.
 *
 * @function handleCloseModalEditarTipoNovedad
 * Closes the edit modal.
 *
 * @function handleChangeRowsPerPage
 * Handles the change in the number of rows per page in the table.
 *
 * @function handleChangePage
 * Handles the change in the current page of the table.
 *
 * @function changePaginationPage
 * Handles the change in the pagination page.
 *
 * @function validateLsPermissions
 * Validates local storage permissions and sets error messages.
 *
 * @function validateResponse
 * Validates the response from API calls and sets error messages.
 */
export const TableUsuariosPermisos = () => {

 
    // USE NAVIGATE 
    const navigate = useNavigate();


    // DISPATCH 
    const dispatch = useDispatch();

  
    // REDUX
    const  {  users_permissions_list }:any  = useSelector( (state:any) => state.usersPermissions );

    

    // USE STATE 
    const [dataTableList, setDataTable] = React.useState([]);
    const [pagination, setPagination] = React.useState<any>({
        "page": 1,
        "take": 1,
        "itemCount": 1,
        "pageCount": 1,
        "hasPreviousPage": false,
        "hasNextPage": false
    });


    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(showNumberRowsTable);
    const [pagePagination, setPagePagination] = React.useState(1);
    const [itemCountPagination, setItemCountPagination] = React.useState(1);


    const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
    const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);


    const [msgErrors, setMsgErrors] = React.useState([]);

    const [openElem, setOpenElem] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  
    const [message_alert_snack, setMessageAlertSnack] = React.useState('');
    const [type_alert_snack, setTypeAlertSnack] = React.useState('success');

    const [canEdit, setCanEdit]     = React.useState<boolean>(false);
    const [canDelete, setCanDelete]     = React.useState<boolean>(false);
    const [canRestore, setCanRestore]     = React.useState<boolean>(false);


    const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);
    

    const [alert_snack, setAlertSnack] = React.useState(false);
    const [msgSnack, setMsgSnack] = React.useState({
        msg: '',
        status: 'success'
    });

    const [modalEditarParameter, setModalEditarTipoNovedad] = React.useState(false);

    

    // USE EFFECT 
    React.useEffect(() => {
      
      if ( users_permissions_list.data && users_permissions_list.data.length > 0 ) {

        setDataTable(users_permissions_list.data);
        setPagination({
          "page": users_permissions_list.meta.page,
          "take": users_permissions_list.meta.take,
          "itemCount": users_permissions_list.meta.itemCount,
          "pageCount": users_permissions_list.meta.pageCount,
          "hasPreviousPage": users_permissions_list.meta.hasPreviousPage,
          "hasNextPage": users_permissions_list.meta.hasNextPage
        });
        setItemCountPagination(users_permissions_list.meta.pageCount);
        
      }
      

    }, [users_permissions_list]);


    React.useEffect(() => {
      getDataUsersPemissions();
    }, []);
    

    React.useEffect(() => {
      checkEdit()
    }, []);
  
    React.useEffect(() => {
        checkCanDelete()
    }, []);
  
    React.useEffect(() => {
      checkRestore()
    }, []);

    // CONST STYLES
    const StyledMenu = styled((props: MenuProps) => (
      <Menu
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        {...props}
      />
    ))(({ theme }) => ({
      '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
          theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
          'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
          padding: '7px 0',
        },
        '& .MuiMenuItem-root': {
          '& .MuiSvgIcon-root': {
            fontSize: 18,
            color: theme.palette.text.secondary,
            marginRight: theme.spacing(1.5),
          },
          '&:active': {
            backgroundColor: alpha(
              theme.palette.primary.main,
              theme.palette.action.selectedOpacity,
            ),
          },
        },
      },
    }));
    
    
    // CONST STYLES 
    const Div = styled('div')(({ theme }) => ({
      ...theme.typography.button,
      backgroundColor: 'wheat',
      padding: theme.spacing(8),
      textAlign: 'center'
    }));

  

    // CONST VALUE
    const open = Boolean(anchorEl);
  
  

    // CONST FUNCTIONS
    const getDataUsersPemissions = async() => {



      // modulo.tiponovedades                             nombre modulo     sub modulo    permission
      const havePermissions = await hasPemissions('modulo.configuracion', 'modulo.usuariospermisos', 'view' );
  
      if( !havePermissions ){
  
        validateLsPermissions('No tienes pemisos para (listar) usuarios permisos.');
  
        return false;                    
         
      }
  
  
      
      const response =  await dispatch( getUsuariosPermisosStore() );
  
  
      await validateResponse(response, ' (Listar Usuarios Permisos) ');

  
    }


    const handleClick = (elem:any) => (event:any) => {
      setAnchorEl(event.currentTarget);
      setOpenElem(elem);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
      setOpenElem(null);
    };
  
  

    const showUserPermissionsDetail = async(userPermissionId:string) => {

      
      const havePermissions = await hasPemissions('modulo.configuracion', 'modulo.usuariospermisos', 'view' );
  
      if( !havePermissions ){
  
        validateLsPermissions('No tienes pemisos para (Listar Usuario Permisos).');
        
        return false;
  
      }
  
      const response =  await dispatch( storeDetailUserPermission(userPermissionId) );


      await validateResponse(response, ' (Listar Usuario Permiso) ');

      if (!response) {
          return false;
      }
      

      navigate("/manager/usuarios-permisos/detalle");


    }




    const showEditUserPermission = async(userPermissionId:string) => {


      

      const havePermissions = await hasPemissions('modulo.configuracion', 'modulo.usuariospermisos', 'edit' );
  
      if( !havePermissions ){
  
        validateLsPermissions('No tienes pemisos para (Editar Usuario Permisos).');
        
        return false;
  
      }
  
      const response = await dispatch( storeDetailUserPermission(userPermissionId) );
      

      await validateResponse(response, ' (Editar Usuario Permiso) ');

      if (!response) {
          return false;
      }

      navigate("/manager/usuarios-permisos/editar");
      

    }
  
  

    const desactiveUserPermission = async(userPermissionId:string) => {


      setAnchorEl(null);
      setOpenElem(null);
      // setButtons(false);

      const havePermissions = await hasPemissions('modulo.configuracion', 'modulo.usuariospermisos', 'delete' );
      

      if( !havePermissions ){

        validateLsPermissions('No tienes pemisos para (desactivar) usuario.');

        return false;                    
         
      }

        
      const response = await dispatch( storeDesActiveUserPermission(userPermissionId) );


      await validateResponse(response, ' (Desactivar Usuario Permiso) ');

  
    }
  
  
    const restoreUserPermission = async(userPermissionId:string) => {


      setAnchorEl(null);
      setOpenElem(null);
      // setButtons(false);

      const havePermissions = await hasPemissions('modulo.configuracion', 'modulo.usuariospermisos', 'restore' );

  
      if( !havePermissions ){
  
        validateLsPermissions('No tienes pemisos para (restaurar) usuario.');
        
        return false;
                                                        
      }
  
  
      const response = await dispatch( storeActiveUserPermission(userPermissionId) );


      await validateResponse(response, ' (Activar Usuario Permiso) ');

  
    }
  
    

    const handleCloseModalEditarTipoNovedad = () => {
         setModalEditarTipoNovedad(false);
    }
  
   

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {

      setRowsPerPage(+event.target.value);

      setPage(0)

    };



    const handleChangePage = (event: unknown, newPage: number) => {

      setPage(newPage);

    };


    const changePaginationPage = async(event: React.ChangeEvent<unknown>, value: number) => {
            
        setPagePagination(value)
    
        const response =  await dispatch( getTipoNovedadByPagination(value) );
        
        await validateResponse(response, ' (Listar Usuario Permiso) ');
        
        
    
    };
    

    const validateLsPermissions = async(message:string) => {

        const errors:any = {
          msg: message,
          status: 'error'
        };
      
        await setMsgSnack(errors);
        await setAlertSnack(true);
      
      
    }


    const validateResponse = async(response:any, textActionConcat: string) => {
      
      
          if (  response.code == 401  ) {
            await localStorage.removeItem('lastSelectedQypht');
            await closeSessionGlobal();
            setModalSessionExpired(true);
            return false;
          }
  
        
          // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
          if (!response.ok && response.code == 403 ) { 
  
            const errors:any = {
              msg: response.errors[0]+' '+textActionConcat,
              status: 'error'
            };
          
            await setMsgSnack(errors);
            await setAlertSnack(true);
  
          
            return false;
  
          }
  
          
          // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
          if (!response.ok && response.code == 400 ) { 
  
              const errors:any = {
                msg: response.errors[0]+' '+textActionConcat,
                status: 'error'
              };
            
              await setMsgSnack(errors);
              await setAlertSnack(true);
  
            
              return false;
  
          }
  
          return true;
          
    }



    const checkEdit = async() => {
    
      const hasPermissionsEdit = await hasPemissions('modulo.configuracion', 'modulo.usuariospermisos', 'edit' );
    
      if ( hasPermissionsEdit ) {
            setCanEdit(true);
      }
    }


  const checkCanDelete = async() => {
      
      const hasPermissionsDelete = await hasPemissions('modulo.configuracion', 'modulo.usuariospermisos', 'delete' );
      
      if ( hasPermissionsDelete ) {
            setCanDelete(true);
      }

  }


  const checkRestore = async() => {
      
      const hasPermissionsRestore = await hasPemissions('modulo.configuracion', 'modulo.usuariospermisos', 'restore' );
        
      if ( hasPermissionsRestore ) {
            setCanRestore(true);
      }

  }

    return (
  
      <>
  
          {/* <MessagesDrawerRight data={msgErrors} title={''} /> */}
          <ModalSessionExpired  open={modalSessionExpired}  />
          <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />

          <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>
  
         {
              
              dataTableList.length > 0
                  
                ?
                <>

                <Card
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    p: 3,
                    borderRadius: 2,
                    boxShadow: 3,
                    bgcolor: 'background.paper',
                    marginTop: paddingCardsTables
                  }}
                >
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>#</StyledTableCell>
                          <StyledTableCell >Foto</StyledTableCell>
                          <StyledTableCell >Nombre</StyledTableCell>
                          <StyledTableCell >Email</StyledTableCell>
                          <StyledTableCell >Estado</StyledTableCell>
                          <StyledTableCell >Acciones</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {dataTableList
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((userPermission:any, index:any) => (
                          <StyledTableRow key={index+1}>
                            <StyledTableCell component="th" scope="row">
                              {index+1}
                            </StyledTableCell>
                            <StyledTableCell component="th" scope="row">
                              <AvatarTables urlImage={userPermission.avatar} typeImage='image-employee' />
                            </StyledTableCell>
                            <StyledTableCell >
                              {userPermission.name}
                            </StyledTableCell>
                            <StyledTableCell >
                              {userPermission.email}
                            </StyledTableCell>

                            <StyledTableCell >
                              {
                                userPermission.status ? <Chip size='small' label="Activo" sx={{ color: '#5DCC0A', background: '#E4F6D6', fontWeight: 700 }} /> : <Chip size='small' label="Inactivo" sx={{ color: '#FF4C51', background: '#FFE2E3', fontWeight: 700 }} />
                              }
                            </StyledTableCell>
                            
                            <StyledTableCell >
                                  
                            
                            {
                            
                                <div> 
                                    <Button
                                      id={`demo-customized-button-${index+1}`}
                                      aria-controls={open ? `demo-customized-menu-${index+1}` : undefined}
                                      aria-haspopup="true"
                                      aria-expanded={open ? 'true' : undefined}
                                      variant="text"
                                      disableElevation
                                      onClick={handleClick(userPermission)}
                                      endIcon={<KeyboardArrowDownIcon />}
                                    >
                                      Acciones
                                    </Button>
                                    <StyledMenu
                                      id={`demo-customized-menu-${index+1}`}
                                      MenuListProps={{
                                        'aria-labelledby': `demo-customized-button-${index+1}`,
                                      }}
                                      anchorEl={anchorEl}
                                      open={openElem === userPermission}
                                      onClose={handleClose}
                                    >
                                      
                                      {
                                        (userPermission.status) 
                                          ? <div>
                                            <MenuItem onClick={ () => showUserPermissionsDetail(userPermission.id) }  disableRipple>
  
                                            <VisibilityIcon />
                                              Detalle 
                                            </MenuItem>

                                            {/* <Divider sx={{ my: 0.5 }} /> */}
                                            {
                                               canEdit &&
                                                  <>
                                                      <MenuItem onClick={ () => showEditUserPermission(userPermission.id) }  disableRipple>
                                                      <EditIcon />
                                                        Editar
                                                      </MenuItem> 
                                                  </>
                                            }
                                          </div>
                                          :
                                          ''
                                      }
                                      
                                      {
                                        (userPermission.status) 
                                        ?
                                          <div>
                                             {
                                                canDelete && 
                                                  <>
                                                     <Divider sx={{ my: 0.5 }} />
                                                     <MenuItem onClick={ () => desactiveUserPermission(userPermission.id) } disableRipple>
                                                       <DeleteIcon />
                                                       Desactivar
                                                     </MenuItem>
                                                  </>
                                             }
                                          </div>
                                        :
                                        <div>
                                           {
                                             canRestore && 
                                                <>
                                                   <Divider sx={{ my: 0.5 }} />
                                                  <MenuItem onClick={ () => restoreUserPermission(userPermission.id) } disableRipple>
                                                    <DeleteIcon />
                                                    Activar
                                                  </MenuItem>
                                                </>
                                           }
                                        </div>
                                        
                                      }
                                      </StyledMenu>
                                  </div>
                        
                            }
            
            
            
            
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Card>
                <TablePagination
                  rowsPerPageOptions={[5, 10]}
                  labelRowsPerPage={'Filas por pagina'}
                  labelDisplayedRows={({ from, to, count }) => ` ${from}-${to} de  ${count} `}
                  component="div"
                  count={pagination.itemCount}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={ handleChangePage }
                  onRowsPerPageChange={ handleChangeRowsPerPage }
                />

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 2,
                    marginBottom: 2
                  }}
                >
                <Pagination sx={{ justifyContent: 'center' }} color="primary" count={itemCountPagination} page={pagePagination} onChange={ changePaginationPage} showFirstButton showLastButton />
                </Box>

                </>


                
                :
                <Div>{"No hay usuario sistema disponibles..."}</Div>
         }
  
  
         
         
      </>
      
    );
}
